import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getAllUserRole = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserRolesNew}?companyCode=${companyCode}`
  );
  return data;
};

const getUserAccess = async ({ companyCode, UserGroupCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserRolesAccessNew}?companyCode=${companyCode}&UserGroupCode=${UserGroupCode}`
  );
  return data;
};

const updateUserRole = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.SaveUserRoleNew,
    input
  );
  return data;
};

export const useGetAllUserRoleQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserRolesNew],
    queryFn: () => getAllUserRole(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetUserAccessQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserRolesAccessNew],
    queryFn: () => getUserAccess(input),
    refetchOnWindowFocus: false,
  });
};

export const useUpdateUserRoleMutation = () => {
  return useMutation({
    mutationFn: updateUserRole,
  });
};
